import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useToast } from 'primevue/usetoast'
import { userApi } from '@/api/modules/user'

export const useUserStore = defineStore('user', () => {
  const toast = useToast()
  // 登录后存储的用户信息
  const token = ref('')
  const vehicleSpeedLevel = ref('')
  // 可根据实际返回字段继续添加
  const userInfo = ref({})

  // 设置用户信息
  function setUserInfo(info) {
    token.value = info.token || ''
    vehicleSpeedLevel.value = info.vehicleSpeedLevel || ''
    userInfo.value = info
  }

  // 清除用户信息
  function clearUserInfo() {
    token.value = ''
    vehicleSpeedLevel.value = ''
    userInfo.value = {}
  }

  // 被移除组织之后，需要切换成个人身份
  async function switchToPersonalIdentity() {
    userInfo.value.identityMode = 'personal'
    // 需要调用切换身份接口
    try {
      const res = await userApi.switchIdentity({ identityMode: 'personal' })
      if (res.code === 200) {
        userInfo.value.identityMode = 'personal'
        userInfo.value.token = res.body.token
        userInfo.value.orgId = null
        userInfo.value.orgName = null
        userInfo.value.orgOwnerId = null
        localStorage.setItem('token', res.body.token)
        token.value = res.body.token
        // 刷新页面
        window.location.reload()
      }
    } catch (error) {
      toast.add({ severity: 'error', summary: 'Error', detail: error?.msg, life: 3000 })
    }
  }

  return {
    token,
    vehicleSpeedLevel,
    userInfo,
    setUserInfo,
    clearUserInfo,
    switchToPersonalIdentity
  }
}, {
  persist: true
}) 